import { getMediaSize } from 'shared/lib'
import { type IResponseMedia } from 'entities/Attachment/api/types'

type IMediaOwner = {
  media?: IResponseMedia[]
  [key: string]: unknown
}

const isSizable = (media: IResponseMedia) =>
  /^(image|video)/.test(media.content_type || '') && !(media.width && media.height)

const collectSizable = (media?: IResponseMedia): IResponseMedia[] => {
  if (!media?.source) return []

  const nested = collectSizable(media.media_preview)

  return isSizable(media) ? [...nested, media] : nested
}

const applySize = async (media: IResponseMedia) => {
  const isVideo = media.content_type.startsWith('video')
  const size =
    (await getMediaSize(media.source, isVideo)) ??
    (media.thumbnail ? await getMediaSize(media.thumbnail) : null)

  if (!size) return

  media.width = size.width
  media.height = size.height
}

export const resolveMediaSizes = async (items: ReadonlyArray<IMediaOwner>) => {
  const sizable = items.flatMap((item) =>
    item.media?.length === 1 ? collectSizable(item.media[0]) : []
  )

  await Promise.all(sizable.map(applySize))
}
